import { useRef } from "react";
import { Section, Reveal, Overline } from "./primitives";
import { INDUSTRIES, PROCESS } from "../../data";
import { motion, useScroll, useTransform } from "framer-motion";

export function Industries() {
  return (
    <Section id="industries">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <Overline>Industries</Overline>
            <h2 className="mt-6 font-display font-bold text-4xl md:text-5xl tracking-tight">
              Built for every <span className="text-gradient">ambition</span>.
            </h2>
          </div>
        </div>
      </Reveal>
      <div className="flex flex-wrap gap-4">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind} delay={(i % 5) * 0.05}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="group rounded-2xl border border-border/10 bg-card px-6 py-5 cursor-default shimmer-card"
            >
              <span className="font-display text-lg font-semibold group-hover:text-gradient transition-colors">{ind}</span>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], ["2%", "-72%"]);

  return (
    <section id="process" ref={ref} className="relative h-[300vh] noise-bg">
      <div className="sticky top-0 h-screen flex flex-col justify-center overflow-hidden">
        <div className="mx-auto max-w-7xl px-6 w-full mb-12">
          <Overline>How We Work</Overline>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight">
            A process built to <span className="text-gradient">compound</span>.
          </h2>
        </div>
        <motion.div style={{ x }} className="flex gap-6 px-6 md:px-[8vw]">
          {PROCESS.map((p) => (
            <div key={p.no} className="relative w-[80vw] sm:w-[42vw] lg:w-[26vw] shrink-0 rounded-3xl border border-border/10 bg-card p-8 md:p-10">
              <span className="font-display text-6xl font-extrabold text-transparent" style={{ WebkitTextStroke: "1.5px hsl(var(--primary))" }}>{p.no}</span>
              <h3 className="mt-6 font-display text-2xl md:text-3xl font-bold tracking-tight">{p.title}</h3>
              <p className="mt-3 text-muted-foreground leading-relaxed">{p.body}</p>
              <div className="mt-8 h-1 w-full rounded-full bg-border/20 overflow-hidden">
                <div className="h-full bg-brand-gradient" style={{ width: `${(parseInt(p.no) / PROCESS.length) * 100}%` }} />
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
